import {
    pickLatestInvoiceNumber,
    suggestNextInvoiceNumber as suggestNextFromFallback,
} from "@helpers/invoiceNumber";
import { AccrualMode } from "./types";

const FALLBACK_BY_MODE: Record<AccrualMode, string> = {
    bill: "BILL-0001",
    invoice: "INV-0001",
};

// Thin, accrual-importer-specific wrapper over the shared invoice-number
// helper: it only maps the importer's `AccrualMode` to the right fallback
// (BILL- vs INV-) and delegates the actual sequencing logic to the helper so
// the increment/compare rules live in exactly one place.
export function suggestNextInvoiceNumber(
    last: string | null | undefined,
    mode: AccrualMode,
): string {
    return suggestNextFromFallback(last, FALLBACK_BY_MODE[mode]);
}

export { pickLatestInvoiceNumber };
